import { IAllocationType, ISimulationInput } from "@defs/Utilities";
import { AllocationType, InputType } from "@utils/appsync/schema/API";

export const ALLOCATION_TYPES: Array<IAllocationType> = [
    {
        id: 0,
        label: "Opex Allocations",
        key: AllocationType.opex_allocation,
    },
    {
        id: 1,
        label: "Manual Journal Entry",
        key: AllocationType.gl_simulation,
    },
];

export const SIMULATION_INPUTS: Array<ISimulationInput<InputType>> = [
    {
        inputId: 0,
        inputLabel: "Definitions",
        inputKey: InputType.allocation_definition,
        systemSelection: false,
    },
    {
        inputId: 1,
        inputLabel: "Mappings",
        inputKey: InputType.allocation_mapping,
        systemSelection: false,
    },
];

export const CUSTOM_DRIVERS_FILE_PREFIX = "custom_drivers";
